import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ArrowRightIcon from '../ArrowRightIcon';

const FundsTable = () => {
  const navigate = useNavigate();
  const breakdown = useSelector((s) => s?.adminReducer?.dashboardFundBreakdown);
  // Normalize possible backend shapes
  const rows = Array.isArray(breakdown?.rows)
    ? breakdown.rows
    : Array.isArray(breakdown) ? breakdown : [];
  const funds = rows.map((r) => ({
    username: r?.user?.name || r?.username || '-',
    email: r?.user?.email || r?.email || '-',
    fundraiser: r?.fundraiser?.user?.name || r?.fundraiser?.name || r?.fundraiser || '-',
    funds: typeof r?.amount === 'number' ? (r.amount / 100).toFixed(2) : (typeof r?.funds === 'number' ? r.funds.toFixed(2) : '-'),
  }));

  return (
    <div className="summary w-full p-4 h-[380px] flex flex-col bg-white rounded-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-[20px] font-poppins font-[600] text-[#303030] leading-none">Funds to be Disbursed (30 Days)</h2>
        <button onClick={()=> navigate('/total-income?tab=to-be-disbursed')} className="text-[#00ADEF] text-[16px] font-poppins font-[500] border border-[#00ADEF] rounded-[6px] px-4 py-2 transition hover:bg-[#E6F7FB] flex items-center">
          View All
          <ArrowRightIcon className="ml-2" />
        </button>
      </div>
      <div className="flex-1 min-h-0 overflow-x-auto">
        {funds.length > 0 ? (
          <table className="min-w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 text-[14px] font-poppins font-[500] text-[#303030] whitespace-nowrap">Username</th>
                <th className="text-left py-3 px-4 text-[14px] font-poppins font-[500] text-[#303030]">Email</th>
                <th className="text-left py-3 px-4 text-[14px] font-poppins font-[500] text-[#303030] whitespace-nowrap">Fundraiser</th>
                <th className="text-left py-3 px-4 text-[14px] font-poppins font-[500] text-[#303030]">Funds</th>
              </tr>
            </thead>
            <tbody>
              {funds.map((fund, index) => (
                <tr key={index} className="border-b border-gray-100">
                  <td className="py-3 px-4 text-[14px] font-poppins text-[#767676] whitespace-nowrap">{fund.username}</td>
                  <td className="py-3 px-4 text-[14px] font-poppins text-[#767676]">{fund.email}</td>
                  <td className="py-3 px-4 text-[14px] font-poppins text-[#767676] whitespace-nowrap">{fund.fundraiser}</td>
                  <td className="py-3 px-4 text-[14px] font-poppins text-[#767676]">${fund.funds}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#767676] text-[14px]">No data</div>
        )}
      </div>
    </div>
  );
};

export default FundsTable; 